/* import __COLOCATED_TEMPLATE__ from './data.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { action } from '@ember/object';

interface Signature {
  Args: {
    onNext?: () => void;
    openSection: string | null;
    setSection?: (section: string | null) => void;
  };
}

export default class ZendeskTicketsData extends Component<Signature> {
  @action
  continue() {
    this.args.onNext?.();
  }

  @action
  setSection(section: string | null) {
    this.args.setSection?.(section);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::Deploy::Tickets::Data': typeof ZendeskTicketsData;
  }
}
